import React, { Component } from 'react'
import SupplierRegistrationForm from '../../../components/Purchasing/SupplierRegistration/SupplierRegistrationForm'
import { Breadcrumb, Card, Layout, Row } from 'antd'

const { Content } = Layout

class SupplierRegistrationApproval extends Component {
  render() {
    const { fetching, list } = this.props
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Vendor</Breadcrumb.Item>
              <Breadcrumb.Item>Registration</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card title={<h1>Vendor Registration</h1>}>
            <SupplierRegistrationForm loading={fetching} supplierRegistration={list} {...this.props} />
          </Card>
        </Row>
      </Content>
    )
  }
}

export default SupplierRegistrationApproval
